/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim2DiagMaxRightIcon20Solid = forwardRef('ArrowDim2DiagMaxRightIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.25 1.875a1.125 1.125 0 0 0 0 2.25h3.034l-3.58 3.58a1.125 1.125 0 0 0 1.591 1.59l3.58-3.579V8.75a1.125 1.125 0 0 0 2.25 0v-5c0-1.036-.84-1.875-1.875-1.875h-5Z" }),
        React.createElement("path", { d: "M4.125 11.25a1.125 1.125 0 0 0-2.25 0v5c0 1.035.84 1.875 1.875 1.875h5a1.125 1.125 0 0 0 0-2.25H5.716l3.58-3.58a1.125 1.125 0 0 0-1.591-1.59l-3.58 3.579V11.25Z" })));
});
